import { render } from "./CampaignView.vue?vue&type=template&id=ddb37240"
import script from "./CampaignView.vue?vue&type=script&lang=js"
export * from "./CampaignView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__